const t = [
  { name: "Jennifer K.", location: "Coralville, IA", text: "University of Iowa sent me to Europe for a research conference and I realized my passport had expired. Fast Passport Center got me a renewal in 5 days — shipped from the Iowa City UPS Store.", service: "Expedited Renewal", days: "5 days" },
  { name: "Marcus T.", location: "Iowa City, IA", text: "My son was accepted to a study abroad program in Japan and we needed his first passport fast. Fast Passport Center walked us through everything and it arrived in 7 days.", service: "New Passport", days: "7 days" },
  { name: "Sarah L.", location: "North Liberty, IA", text: "Emergency situation — passport stolen two days before my flight to London for a work event. They had a plan for me within an hour. Emergency passport arrived the next day.", service: "Emergency Replacement", days: "24 hours" },
];

export default function IowaCityTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Real Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">What Iowa City Travelers Say</h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">Johnson County travelers trust Fast Passport Center for their most urgent passport needs.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {t.map((item, i) => (
            <div key={i} className="bg-white rounded-lg p-6 border border-gray-200">
              <div className="flex items-center gap-0.5 mb-4">{[...Array(5)].map((_, j) => <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>)}</div>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">"{item.text}"</p>
              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <div><p className="font-bold text-[#1A365D] text-sm">{item.name}</p><p className="text-gray-400 text-xs">{item.location}</p></div>
                <div className="text-right"><span className="inline-block bg-[#EEF2F8] text-[#1A365D] text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">{item.service}</span><p className="text-gray-400 text-xs mt-1">{item.days}</p></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}